module.exports = __webpack_public_path__ + "img/source_sw-at02.9eb45278.png";